var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": "",
      "width": "100%"
    }
  }, [!_vm.items || _vm.items.length < 1 ? [_c('v-row', {
    staticClass: "flex-column",
    attrs: {
      "dense": "",
      "align": "center",
      "justify": "start"
    }
  }, [_c('p', {
    staticClass: "disabled--text"
  }, [_vm._v("No additional details.")])])] : _vm._l(_vm.items, function (field, key) {
    return _c('v-row', {
      key: key + 'cfrow',
      attrs: {
        "dense": "",
        "align": "center"
      }
    }, [_c('v-col', {
      staticClass: "subheading primary--text font-weight-bold d-flex flex-grow-1"
    }, [_vm._v(" " + _vm._s(field.name) + " ")]), _c('v-col', {
      staticClass: "d-flex flex-grow-1 flex-shrink-1"
    }, [_vm._v(_vm._s(field.value))]), _c('v-col', {
      staticClass: "d-flex flex-grow-0 flex-shrink-1"
    })], 1);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }